// extracted by mini-css-extract-plugin
module.exports = {"VersionControlModule":"VersionControl_VersionControlModule__3qPMa"};